import Rails from 'rails-ujs';

// 次フィールドのヒント(赤枠)のクラス
// 主にLP画面で使用する
// 現在はLP2、LP8限定で動くように全てのメソッドにapproveFieldHintUrが走る
export default class NextFieldHint {

  static approveFieldHintUrl() {
    // LP2 LP3 LP4 LP8 LP9 LP10 LP11のみフィールドヒントを表示する
    return (location.href.indexOf("pix/lp2") !== -1) || (location.href.indexOf("pix/lp3") !== -1) || (location.href.indexOf("pix/lp4") !== -1)
      || (location.href.indexOf("pix/lp8") !== -1 || (location.href.indexOf("pix/lp9") !== -1)) || (location.href.indexOf("pix/lp10") !== -1)
      || (location.href.indexOf("pix/lp11") !== -1);
  }

  static removeFieldHint(input){
    if(!this.approveFieldHintUrl()) return;

    input.classList.remove('field_hint');
  }

  static addProductCategorySelectBlock(selectNumber){
    if(!this.approveFieldHintUrl()) return;

    const selectNumberText = selectNumber.toString();

    const mutationObserver = new MutationObserver(() => {
      if (Rails.$(`#productCategorySelectBlock${selectNumberText} button`).length) {
        Rails.$(`#productCategorySelectBlock${selectNumberText} button`)[0].classList.add('field_hint');
        mutationObserver.disconnect();
      }
    });

    mutationObserver.observe(
      document.getElementById(`productCategorySelectBlock${selectNumberText}`),
      {
        childList: true,
        subtree: true
      }
    );
  }

  static addItemNameFieldHint(){
    if(!this.approveFieldHintUrl()) return;
    const hiddenItemNameField = document.getElementById('hidden_item_name_field');
    if(!hiddenItemNameField){
      const itemNameField = document.getElementById('item_name');
      itemNameField.classList.add('field_hint');
    }else{
      const itemImageField = document.getElementsByClassName('for-DragDrop hint')[0];
      itemImageField.classList.add('file_field_hint');
    }
  }

  static realtimeFieldHint(condition, element){
    if(!this.approveFieldHintUrl()) return;

    const $requiredFields = Rails.$('.hint');

    $requiredFields.forEach((field, index) => {
      if(element !== field) return;

      // 次のフィールドが存在しない場合はreturn
      if($requiredFields[index + 1] === null) return;

      const nextField = $requiredFields[index + 1];

      // 正しい値ならヒントを外す
      if (condition) {
        element.classList.remove('field_hint');
        nextField.classList.add('field_hint');
      } else {
        element.classList.add('field_hint');
      }
    });
  }

  static changeBirthFieldHint(event){
    if(!this.approveFieldHintUrl()) return;

    if (event.target.id.includes('birth_year')){
      const yearField = document.getElementById('birth_year');
      const monthField = document.getElementById('birth_month');
      if(yearField.value){
        yearField.nextElementSibling.classList.remove('field_hint');
        monthField.nextElementSibling.classList.add('field_hint');
      }else{
        yearField.nextElementSibling.classList.add('field_hint');
        monthField.nextElementSibling.classList.remove('field_hint');
      }
    }

    if (event.target.id.includes('birth_month')){
      const monthField = document.getElementById('birth_month');
      const dayField = document.getElementById('birth_day');
      if(monthField.value){
        monthField.nextElementSibling.classList.remove('field_hint');
        dayField.nextElementSibling.classList.add('field_hint');
      }else{
        monthField.nextElementSibling.classList.add('field_hint');
        dayField.nextElementSibling.classList.remove('field_hint');
      }
    }

    if (event.target.id.includes('birth_day')){
      const dayField = document.getElementById('birth_day');
      const userSexField = document.getElementById('user_sex');
      if(dayField.value){
        dayField.nextElementSibling.classList.remove('field_hint');
        userSexField.nextElementSibling.classList.add('field_hint');
      }else{
        dayField.nextElementSibling.classList.add('field_hint');
        userSexField.nextElementSibling.classList.remove('field_hint');
      }
    }
  }

  static changeGenderSelectorHint(event){
    if(!this.approveFieldHintUrl()) return;

    if (event.target.id.includes('user_sex')){
      const userSexField = document.getElementById('user_sex');
      const userJobField = document.getElementById('user_job');

      if(event.target.validity['valid']){
        userSexField.nextElementSibling.classList.remove('field_hint');
        userJobField.nextElementSibling.classList.add('field_hint');
      }else{
        userSexField.nextElementSibling.classList.add('field_hint');
        userJobField.nextElementSibling.classList.remove('field_hint');
      }
    }
  }

  static changeJobSelectorHint(event){
    if(!this.approveFieldHintUrl()) return;

    if (event.target.id.includes('user_job')){
      const userJobField = document.getElementById('user_job');

      if(event.target.validity['valid']){
        userJobField.nextElementSibling.classList.remove('field_hint');
      }else{
        userJobField.nextElementSibling.classList.add('field_hint');
      }
    }
  }

  static changeItemNameFieldHint(event){
    if(!this.approveFieldHintUrl()) return;

    const itemNameField = document.getElementById('item_name');
    const itemImageField = document.getElementsByClassName('for-DragDrop hint')[0];
    if(event.target.validity['valid']){
      itemNameField.classList.remove('field_hint');
      itemImageField.classList.add('file_field_hint');
    }else{
      itemNameField.classList.add('field_hint');
      itemImageField.classList.remove('file_field_hint');
    }
  }

  static changeItemImageFieldHint(event){
    if(!this.approveFieldHintUrl()) return;

    const itemImageField = document.getElementsByClassName('for-DragDrop hint')[0];
    const userName = document.getElementById('user_name');
    if(event.target.validity['valid']){
        itemImageField.classList.remove('file_field_hint');
        userName.classList.add('field_hint');
      }else{
        itemImageField.classList.add('file_field_hint');
        userName.classList.remove('field_hint');
      }
  }

  static changeFllNameFieldHint(event){
    if(!this.approveFieldHintUrl()) return;

    if (event.target.id === 'user_last_name'){
      const lastNameField = document.getElementById('user_last_name');
      const lastNameValue = lastNameField.value;
      this.realtimeFieldHint(lastNameValue !== '', lastNameField);
    }

    if (event.target.id === 'user_first_name'){
      const firstNameField = document.getElementById('user_first_name');
      const firstNameValue = firstNameField.value;
      this.realtimeFieldHint(firstNameValue !== '', firstNameField);
    }
  }

  static changePostalCodeFieldHint(){
    if(!this.approveFieldHintUrl()) return;

    const postalCodeField = document.getElementById('user_postal_code');
    const postalCodeValue = postalCodeField.value;
    this.realtimeFieldHint(postalCodeValue.match(/[0-9]{7}/), postalCodeField);
  }

  static changeTelNumberFieldHint(event){
    if(!this.approveFieldHintUrl()) return;

    const userTelField = document.getElementById('user_tel');
    const yearField = document.getElementById('birth_year');
    if(event.target.validity['valid']){
      userTelField.classList.remove('field_hint');
      yearField.nextElementSibling.classList.add('field_hint');
    }else{
      userTelField.classList.add('field_hint');
      yearField.nextElementSibling.classList.remove('field_hint');
    }
  }

  static changeRequiredFieldHint(e){
    if(!this.approveFieldHintUrl()) return;

    const target = document.getElementById(`${e.target.id}_field`);
    const requiredField = target.getElementsByClassName('required')[0];
    if(requiredField){
      this.realtimeFieldHint(e.target.validity['valid'], requiredField);
    }
  }
}
